import React from "react";
import Tile from "@amzn/meridian/tile";
import { IEventTileProps } from "./definitions";
import { useAppDispatch } from "../../app/store/hooks";
import { useTable } from "../table/hooks";
import { useFilterSheets } from "../../features/filter-sheets/hooks";
import { formatToStartCase } from "../../utils/formattingUtils";
import Text from "@amzn/meridian/text";
import { Space } from "../space/Space";

export const EventTile: React.FC<IEventTileProps> = ({
    message,
    accent,
    isDisabled,
    status,
    documentType,
    setCalendarTableQuery,
    date,
    documentTypeCount,
}) => {
    const dispatch = useAppDispatch();
    const { setCalendarTableVisible } = useTable();
    const { resetFilters } = useFilterSheets();

    return (
        <Tile
            accent={accent}
            disabled={isDisabled ?? false}
            onClick={() => {
                setCalendarTableQuery({ status: [status], documentType: documentType, date: date });
                dispatch(setCalendarTableVisible(true));
                dispatch(resetFilters());
            }}
        >
            <Text type={"h50"}>{`${documentTypeCount} ${formatToStartCase(documentType)}`}</Text>
            <Space size={"xs"} />
            <Text>{message}</Text>
        </Tile>
    );
};
